<template>
  <v-toolbar-items>
    <v-toolbar-items>
      <v-btn text @click="handleCommand('exec-comp-public')">
        <v-icon>people</v-icon>
        Public Data
      </v-btn>
    </v-toolbar-items>
    <v-toolbar-items>
      <v-btn
        :disabled="!accessRights.includes('all') && !accessRights.includes('exec_comp_private')"
        text @click="handleCommand('exec-comp-private')">
        <v-icon>assignment_ind</v-icon>
        Private Data
      </v-btn>
    </v-toolbar-items>
    <v-toolbar-items>
      <v-btn text @click="cortabledialog = true">
        <v-icon>table_chart</v-icon>
        Correlation Table
      </v-btn>
      <v-dialog v-model="cortabledialog">
        <v-card title="MRC Correlation Table" width='90%' style="margin:auto;">
          <v-img
            class="text-white" style="margin:30px;"
            src="https://www.mrc-asia.com/api/file/download_center/mrc_jes_correlation_guide.png"
          ></v-img>
        </v-card>
      </v-dialog>
    </v-toolbar-items>
    <v-toolbar-items>
      <v-btn text href="https://www.mrc-asia.com/online_services" target="_blank">
        <v-icon>apps</v-icon>
        My Subscriptions
      </v-btn>
    </v-toolbar-items>
    <v-menu :nudge-width="280">
      <!-- <v-toolbar-items slot="activator"> -->
        <template v-slot:activator="{ on }">
          <v-btn v-show="false" v-on="on" text style="padding: 20px;">
            <v-icon>apps</v-icon>
          </v-btn>
        </template>
      <!-- </v-toolbar-items> -->
      <v-list style="width:100%;padding-left:10px;padding-right:10px;padding-top: 25px;">
        <div v-for="(mitem,i) in moreservices" :key="`3${i}`"
          class="mb-2 mx-2 d-flex box">
            <v-btn :disabled="mitem.disabled" fab x-small :color="mitem.color"
                     @click="handleCommand(mitem.command)">
              <i class="material-icons" style="font-size:2.2em;color:#f5f5f5;">{{mitem.icon}}</i>
            </v-btn>
            <a :disabled="mitem.disabled"
                    @click="handleCommand(mitem.command)">
              <h4 v-html="mitem.module" :class="{mute:mitem.disabled}"
              class="ml-4 mt-2 font-weight-light" style="color:#36454f;"></h4>
            </a>
        </div>
      </v-list>
    </v-menu>
  </v-toolbar-items>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      cortabledialog: false,
    };
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case 'exec-comp-public':
          window.location.href = '/exec-comp/#/public';
          break;
        case 'exec-comp-private':
          window.location.href = '/exec-comp-private';
          break;
        case 'super-comp-ml':
          window.location.href = '/super-comp';
          break;
        case 'employee-benefits':
          window.location.href = '/employee-benefits';
          break;
        case 'mi':
          window.location.href = '/mi';
          break;
        case 'sip':
          window.location.href = '/sip';
          break;
        case 'super-comp-actual':
          window.location.href = '/core-comp';
          break;
        case 'on-demand-survey':
          window.location.href = '/dcc';
          break;
        case 'job-evaluation':
          window.location.href = '/jes';
          break;
        case 'market-insight':
          window.location.href = '/market_insights_members';
          break;
        case 'aims':
          window.location.href = '/aims';
          break;
        case 'symposium':
          window.location.href = '/seminar_members';
          break;
        case 'erp':
          window.location.href = '/erp';
          break;
        default:
      }
    },
  },
  computed: {
    moreservices() {
      return [
        {
          module: 'Executive Compensation Public',
          color: 'warning',
          icon: 'people',
          command: 'exec-comp-public',
          disabled: !this.accessRights.includes('all') && !this.accessRights.includes('exec_comp_public'),
        },
        {
          module: 'Executive Compensation Private',
          color: 'primary',
          icon: 'assignment_ind',
          command: 'exec-comp-private',
          disabled: !this.accessRights.includes('all') && !this.accessRights.includes('exec_comp_private'),
        },
        {
          module: 'Super Compensation',
          color: 'info',
          icon: 'adb',
          command: 'super-comp-ml',
          disabled: !this.accessRights.includes('all') && !this.accessRights.includes('super_comp'),
        },
        {
          module: 'Employee Benefits',
          color: 'warning',
          icon: 'card_membership',
          command: 'employee-benefits',
          disabled: !this.accessRights.includes('all') && !this.accessRights.includes('employee_benefits'),
        },
        {
          module: 'APAC Market Insights',
          color: 'primary',
          icon: 'analytics',
          command: 'mi',
          disabled: !this.accessRights.includes('all') && !this.accessRights.includes('mi_survey'),
        },
        {
          module: 'Sales Incentive Practices',
          color: 'info',
          icon: 'point_of_sale',
          command: 'sip',
          disabled: !this.accessRights.includes('all') && !this.accessRights.includes('sip'),
        },
        {
          module: 'Job Evaluation System',
          color: 'warning',
          icon: 'table_chart',
          command: 'job-evaluation',
          disabled: !this.accessRights.includes('all') && !this.accessRights.includes('jes'),
        },
        {
          module: 'Employee Risk Predictor',
          color: 'primary',
          icon: 'cloud',
          command: 'erp',
          disabled: !this.accessRights.includes('all') && !this.accessRights.includes('erp'),
        },
        {
          module: 'Symposium Materials',
          color: 'info',
          icon: 'description',
          command: 'symposium',
          disabled: !this.accessRights.includes('all') && !this.accessRights.includes('seminar_material'),
        },
        {
          module: 'Monthly Market Insights',
          color: 'warning',
          icon: 'system_update',
          command: 'market-insight',
          disabled: !this.accessRights.includes('all') && !this.accessRights.includes('econ_guide'),
        },
        {
          module: 'AI Market Sensor for HR',
          color: 'primary',
          icon: 'view_comfy',
          command: 'aims',
          disabled: !this.accessRights.includes('all') && !this.accessRights.includes('mds')
            && !this.accessRights.includes('aims.nonrewards') && !this.accessRights.includes('forecast_calculator')
            && !this.accessRights.includes('hr_markets') && !this.accessRights.includes('pay_trends')
            && !this.accessRights.includes('relocation') && !this.accessRights.includes('legislations_news')
            && !this.accessRights.includes('finance_productivity') && !this.accessRights.includes('economy'),
        },
      ];
    },
    ...mapState(['accessRights']),
  },
};
</script>

<style>
  .mute {
    color: gray;
  }
  .box {
    transition: box-shadow .3s;
    border-radius:10px;
    background: #fff;
    padding:8px;
  }
  .box:hover {
    box-shadow: 0 0 11px rgba(33,33,33,.2);
  }
</style>
